import { DEFAULT_DATE_FORMAT_PATTERN } from "../../../../shared/DataFormatSection/constants";
import type { FootnoteSymbolOption, QuerySettingsValues } from "./types";
// Format-option lists live with the reusable section. Re-export so callers
// inside the panel (e.g. `__tests__`) can keep `from "../constants"` paths.
export type { SelectOption } from "../../../../shared/DataFormatSection/types";
export {
  CURRENCY_SYMBOL_POSITION_OPTIONS,
  DEFAULT_DATE_FORMAT_PATTERN,
  NEGATIVE_NUMBERS_OPTIONS,
  NULL_DISPLAY_OPTIONS,
  NUMBER_SCALE_OPTIONS,
  ZERO_DISPLAY_OPTIONS,
} from "../../../../shared/DataFormatSection/constants";
// `OPERATOR_OPTIONS` lives with the reusable rules section.
export { OPERATOR_OPTIONS } from "../../../../shared/RulesSection/constants";
import type { SelectOption } from "../../../../shared/DataFormatSection/types";

export const NAME_MAX_LENGTH = 100;

export const DECIMAL_PLACES_OPTIONS: ReadonlyArray<SelectOption<number>> = [
  { value: 0, label: "0" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
];

export const FOOTNOTE_SYMBOL_OPTIONS: ReadonlyArray<SelectOption<FootnoteSymbolOption>> = [
  { value: "numeric", label: "Numbers (1, 2, 3,\u2026)" },
  { value: "lowercase_letters", label: "Lowercase letters (a, b, c,\u2026)" },
  { value: "uppercase_letters", label: "Uppercase letters (A, B, C,\u2026)" },
  { value: "lowercase_roman", label: "Lowercase roman numerals (i, ii, iii,\u2026)" },
  { value: "uppercase_roman", label: "Uppercase roman numerals (I, II, III,\u2026)" },
  { value: "symbols", label: "Symbols (*, \u2020, \u2021, \u00a7, \u2016, \u00b6)" },
];

/** Short form used in the footnote panel's "Override query default (<style>)"
 * toggle label, where the parenthetical names the inherited
 * query-level symbol style. */
export const FOOTNOTE_SYMBOL_SHORT_LABELS: Record<FootnoteSymbolOption, string> = {
  numeric: "Numbers",
  lowercase_letters: "Lowercase letters",
  uppercase_letters: "Uppercase letters",
  lowercase_roman: "Lowercase roman numerals",
  uppercase_roman: "Uppercase roman numerals",
  symbols: "Symbols",
};

export const DEFAULT_QUERY_SETTINGS_VALUES: QuerySettingsValues = {
  name: "",
  supportedTemplateType: "ACCOUNT_STATEMENT",
  supportedTransactionTypes: [],
  decimalPlaces: 2,
  footnoteSymbol: "numeric",

  formatWithinQuery: true,
  negativeNumbers: "parentheses",
  numberScale: "as_is",
  thousandsSeparator: true,
  showCurrencySymbol: true,
  currencySymbolPosition: "left",
  zeroDisplay: "number",
  nullDisplay: "blank",
  dateFormatPattern: DEFAULT_DATE_FORMAT_PATTERN,

  filterRules: { groupsOperator: "and", groups: [] },
  suppressionRules: { groupsOperator: "and", groups: [] },
};
